import { isMobileDevice } from "./mobile-device";
import { startup } from "./startup";
import { applyLanguage, getLanguage } from "./ui/i18n";

applyLanguage();

// Initialize error handling before any game module executes its static imports.
await startup({
  isMobile: isMobileDevice(),
  language: getLanguage(),
  location,
  head: document.head,
  createLink: () => document.createElement("link"),
  mountAdminSettings: async () => (await import("./ui/AdminSettings")).mountAdminSettings(),
  listenForInstall: async () => (await import("./ui/install-prompt")).listenForInstall(),
  initializeTelemetry: async () => (await import("./telemetry/client")).initializeClientTelemetry(),
  loadGame: () => import("./game"),
  showGuide: async () => (await import("./ui/hud/screens/menu")).showMenuPage("guide"),
});
